/** 券兑换状态 */
export var ExchangeState;
(function (ExchangeState) {
    /** 未开始 */
    ExchangeState[ExchangeState["notStarted"] = 1] = "notStarted";
    /** 可兑换，展示库存 */
    ExchangeState[ExchangeState["avaliable"] = 2] = "avaliable";
    /** 奖品维度-日限额 今日已领完 */
    ExchangeState[ExchangeState["dayLimit"] = 3] = "dayLimit";
    /** 奖品维度-总限额 券已售罄 */
    ExchangeState[ExchangeState["totalLimit"] = 4] = "totalLimit";
    /** 用户维度-总限额 */
    ExchangeState[ExchangeState["totalUserLmit"] = 5] = "totalUserLmit";
    /** 用户维度-月限额 */
    ExchangeState[ExchangeState["monthUserLimit"] = 6] = "monthUserLimit";
    /** 印花不足 */
    ExchangeState[ExchangeState["qualNoEnough"] = 7] = "qualNoEnough";
})(ExchangeState || (ExchangeState = {}));
